import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth';
import { Auth } from '@angular/fire/auth';
import { environment } from '../../../environments/environment';

export const adminAppGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  	const authService           = inject(AuthService);
    const router                = inject(Router);
    const socioPlatformLoginUrl = environment.production
        ? 'https://cliente.innovate-gua.com/login'
        : 'https://socio-dev.innovate-gua.com/login';
    const firebaseAuthInstance  = authService.authInstance as Auth;
    const currentUser           = firebaseAuthInstance.currentUser;

    if(!currentUser) {
        return true;
    }

    return from(currentUser.getIdTokenResult()).pipe(
        map(idTokenResult => {
            const roles: string[] = (idTokenResult.claims && Array.isArray(idTokenResult.claims['roles'])) ? idTokenResult.claims['roles'] as string[] : [];

            if(roles.includes('partner')) {
                window.location.href = socioPlatformLoginUrl;

                return false;
            } else {
                return true;
            }
        }), catchError((error) => {
            console.error('Error al obtener el token ID del usuario en adminAppGuard:', error);

            return of(router.createUrlTree(['']));
        })
    );
};
